var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "shop-by-pattern",
      class: _vm.schema.settings.backgroundColor,
      style: {
        "padding-top": _vm.schema.settings.marginTop + "px",
        "padding-bottom": _vm.schema.settings.marginBottom + "px"
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "shop-by-pattern__header" }, [
            _c(
              "div",
              {
                staticClass: "shop-by-pattern__title h3",
                class: _vm.schema.settings.titleColor
              },
              [_vm._v(_vm._s(_vm.schema.settings.title))]
            ),
            _c(
              "div",
              {
                staticClass:
                  "shop-by-pattern_desc body-sm-mobile body-lg-tablet-up",
                class: _vm.schema.settings.descriptionColor
              },
              [_vm._v(_vm._s(_vm.schema.settings.description))]
            )
          ]),
          _c(
            "div",
            { staticClass: "shop-by-pattern__collection-list" },
            _vm._l(_vm.validCollectionBlocks, function(block, index) {
              return _c(
                "div",
                {
                  key: block.id,
                  staticClass: "shop-by-pattern__collection-container",
                  class: {
                    "shop-by-pattern__collection-container--selected":
                      _vm.currentIndex === index
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "shop-by-pattern__collection",
                      style: {
                        "background-image":
                          "url(" + block.settings.collection_image + ")"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setCurrentIndex(index)
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "shop-by-pattern__collection-overlay",
                        class: block.settings.overlay_color,
                        style: { opacity: block.settings.overlay_opacity / 100 }
                      }),
                      _c(
                        "div",
                        { staticClass: "shop-by-pattern__collection-content" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "shop-by-pattern__collection-title h2-mobile h4-tablet-up",
                              class: _vm.schema.settings.collectionTitleColor
                            },
                            [_vm._v(_vm._s(block.settings.collection_title))]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "shop-by-pattern__collection-button",
                              class: _vm.schema.settings.ctaStyle,
                              attrs: {
                                href:
                                  "/collections/" +
                                  block.settings.collection_handle
                              }
                            },
                            [
                              _c("span", { staticClass: "button__content" }, [
                                _vm._v("Shop All")
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "shop-by-pattern__collection-tooltip-container"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "shop-by-pattern__collection-tooltip-border",
                        class: [_vm.schema.settings.productBorderColor]
                      }),
                      _c("div", {
                        staticClass: "shop-by-pattern__collection-tooltip",
                        class: [
                          _vm.schema.settings.productBackgroundColor.replace(
                            "bg",
                            "border"
                          )
                        ]
                      })
                    ]
                  )
                ]
              )
            }),
            0
          ),
          _c(
            "swiper",
            {
              ref: "patternSwiper",
              staticClass:
                "shop-by-pattern__collection-list shop-by-pattern__collection-list--mobile",
              attrs: { options: _vm.swiperOptions }
            },
            _vm._l(_vm.validCollectionBlocks, function(block) {
              return _c(
                "swiperSlide",
                {
                  key: block.id,
                  staticClass: "shop-by-pattern__collection",
                  style: {
                    "background-image":
                      "url(" + block.settings.collection_image + ")"
                  },
                  attrs: { "data-collection": block.settings.collection_handle }
                },
                [
                  _c("div", {
                    staticClass: "shop-by-pattern__collection-overlay",
                    class: block.settings.overlay_color,
                    style: { opacity: block.settings.overlay_opacity / 100 }
                  }),
                  _c(
                    "div",
                    { staticClass: "shop-by-pattern__collection-content" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "shop-by-pattern__collection-title h2-mobile h4-tablet-up",
                          class: _vm.schema.settings.collectionTitleColor
                        },
                        [_vm._v(_vm._s(block.settings.collection_title))]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "shop-by-pattern__collection-button",
                          class: _vm.schema.settings.ctaStyle,
                          attrs: {
                            href:
                              "/collections/" + block.settings.collection_handle
                          }
                        },
                        [
                          _c("span", { staticClass: "button__content" }, [
                            _vm._v("Shop All")
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticClass: "shop-by-pattern__product-container",
              class: [
                _vm.schema.settings.productBackgroundColor,
                _vm.schema.settings.productBorderColor
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "shop-by-pattern__collection-tooltip-container shop-by-pattern__collection-tooltip-container--mobile"
                },
                [
                  _c("div", {
                    staticClass: "shop-by-pattern__collection-tooltip-border",
                    class: [_vm.schema.settings.productBorderColor]
                  }),
                  _c("div", {
                    staticClass: "shop-by-pattern__collection-tooltip",
                    class: [
                      _vm.schema.settings.productBackgroundColor.replace(
                        "bg",
                        "border"
                      )
                    ]
                  })
                ]
              ),
              _c(
                "fade-transition",
                { attrs: { duration: { enter: 600, leave: 200 } } },
                [
                  !_vm.isLoading
                    ? _c(
                        "div",
                        {
                          key: _vm.currentIndex,
                          staticClass: "shop-by-pattern__product-list"
                        },
                        _vm._l(_vm.productListByView, function(product, index) {
                          return _c("product-tile", {
                            key: product.id,
                            attrs: {
                              widget: true,
                              product: Object.assign({}, product, {
                                options: [],
                                variants: []
                              })
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "fade-transition",
                { attrs: { duration: { enter: 600, leave: 200 } } },
                [
                  _vm.isLoading
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "shop-by-pattern__product-list shop-by-pattern__product-list--loading"
                        },
                        _vm._l(_vm.productCount[_vm.$mq], function(tile) {
                          return _c("product-tile-skeleton", { key: tile })
                        }),
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }